import useAuthenticatedFetch from "@/hooks/useAuthenticatedFetch.ts";
import { apiUrl } from "@/utils/api.ts";
import { type UseMutationResult, useMutation, useQueryClient } from "@tanstack/react-query";
import { handleJsonApiError } from "jsonapi-zod-query";

export const useSavePersonDLN = (): UseMutationResult<
    void,
    Error,
    { personId: string; personUUID: string; dlNumber: string }
> => {
    const fetch = useAuthenticatedFetch();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async ({ personUUID, dlNumber }) => {
            const response = await fetch(apiUrl(`/person/save-dln/${personUUID}`), {
                method: "POST",
                headers: {
                    "Content-Type": "application/vnd.api+json",
                },
                body: JSON.stringify({
                    dlNumber: dlNumber,
                }),
            });
            await handleJsonApiError(response);
        },
        onSuccess: async (_, { personId }) => {
            await queryClient.invalidateQueries({
                queryKey: ["person", personId],
            });
        },
    });
};
